"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var css_1 = require("@emotion/css");
// eslint-disable-next-line no-unused-expressions
(0, css_1.injectGlobal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["@import url('//fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700');"], ["@import url('//fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700');"])));
var Text = function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? "primary" : _b, italic = _a.italic, _c = _a.size, size = _c === void 0 ? 14 : _c, _d = _a.weight, weight = _d === void 0 ? "regular" : _d, _e = _a.lineHeight, lineHeight = _e === void 0 ? 1.6 : _e, restProps = __rest(_a, ["className", "color", "italic", "size", "weight", "lineHeight"]);
    var textClass = (0, css_1.css)({
        fontFamily: "'Roboto', -system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';",
        lineHeight: lineHeight,
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        fontSize: "var(--font-font-size-".concat(size, ")"),
        fontWeight: "var(--font-font-weight-".concat(weight, ")"),
        fontStyle: italic ? "italic" : undefined,
        color: color === "link" ? "var(--color-text-link-default)" : "var(--color-text-".concat(color, ")")
    });
    var linkHoverClass = (0, css_1.css)({
        "&:hover": {
            color: "var(--color-text-link-hover)",
            textDecoration: "underline",
            cursor: "pointer"
        }
    });
    return (0, jsx_runtime_1.jsx)("span", __assign({}, restProps, { className: (0, css_1.cx)(textClass, color === "link" && linkHoverClass, className) }));
};
exports.Text = Text;
var templateObject_1;
